import { jsonFetch } from "@/lib/helpers";
import { getAlarmRuleUrl } from "./api-url.constants";
import { AlarmRuleDTO, UpdateAlarmRuleBodyDTO } from "./dtos";
import { API_METHODS } from "../shared";

type UpdateAlarmRuleResponse = {
  data: AlarmRuleDTO;
};

export const updateAlarmRule = async (
  id: string,
  body: UpdateAlarmRuleBodyDTO
): Promise<AlarmRuleDTO> => {
  const response = await jsonFetch<UpdateAlarmRuleResponse>(getAlarmRuleUrl(id), {
    method: API_METHODS.PUT,
    body: JSON.stringify(body),
  });
  return response.data;
};
